import { render, staticRenderFns } from "./SectionLayoutCard.vue?vue&type=template&id=2df07edd&scoped=true&"
import script from "./SectionLayoutCard.vue?vue&type=script&lang=ts&"
export * from "./SectionLayoutCard.vue?vue&type=script&lang=ts&"
import style0 from "./SectionLayoutCard.vue?vue&type=style&index=0&id=2df07edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df07edd",
  null
  
)

export default component.exports